"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var svgs_1 = require("../../../../assets/svgs");
var old_1 = require("../../../../old");
var utils_1 = require("../../../../utils");
var AlertIcon_1 = require("../../../display/AlertIcon");
function AlertItem(_a) {
    var uuid = _a.uuid, timeCreated = _a.timeCreated, title = _a.title, riskScore = _a.riskScore, onPress = _a.onPress, onCheckboxPress = _a.onCheckboxPress, selected = _a.selected, isBulkSelectMode = _a.isBulkSelectMode, _b = _a.snoozed, snoozed = _b === void 0 ? false : _b, _c = _a.showDeviceName, showDeviceName = _c === void 0 ? false : _c, _d = _a.Link, Link = _d === void 0 ? null : _d, _e = _a.isDesktop, isDesktop = _e === void 0 ? false : _e;
    var theme = (0, material_1.useTheme)();
    var color = (0, utils_1.riskScoreToSeverity)(riskScore, snoozed).color;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ onClick: onPress, sx: {
            display: 'flex',
            backgroundColor: selected
                ? theme.palette.primary[200]
                : snoozed
                    ? theme.palette.primary[700]
                    : theme.palette.common.white,
            '& .right-arrow': {
                transform: 'translateX(0)',
                transitionDuration: '300ms ',
            },
            '&:hover': {
                cursor: 'pointer',
                '& .right-arrow': {
                    transform: 'translateX(100%)',
                    transitionDuration: '300ms ',
                },
                '& .right-arrow path': {
                    stroke: theme.palette.primary.main,
                },
                // Desktop version currently doesn't have a checkbox
                '& .alert-icon': {
                    display: isDesktop ? 'flex' : 'none',
                },
                '& .checkbox': {
                    display: isDesktop ? 'none' : 'flex',
                },
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    width: '4px',
                    backgroundColor: color,
                } }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                    flex: 1,
                    paddingTop: isDesktop ? '1.6rem' : '2.8rem',
                    paddingBottom: isDesktop ? '1.6rem' : '2.8rem',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: isDesktop ? '2.4rem' : '2.8rem',
                } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                            display: 'flex',
                            alignSelf: 'flex-start',
                            alignItems: 'center',
                            width: isDesktop ? '4.0rem' : '4.8rem',
                            height: isDesktop ? '4.0rem' : '4.8rem',
                            '& .alert-icon': {
                                display: isBulkSelectMode ? 'none' : 'flex',
                            },
                            '& .checkbox': {
                                display: isBulkSelectMode ? 'flex' : 'none',
                            },
                        }, onClick: function (e) { return e.stopPropagation(); } }, { children: [(0, jsx_runtime_1.jsx)(AlertIcon_1.AlertIcon, { riskScore: riskScore, snoozed: snoozed, width: isDesktop ? '4.0rem' : '4.8rem', height: isDesktop ? '4.0rem' : '4.8rem', isDesktop: isDesktop }), (0, jsx_runtime_1.jsx)(old_1.ThemedCheckbox, { checked: selected, onChange: onCheckboxPress })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                            marginLeft: '28px',
                        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                    padding: 0,
                                    margin: 0,
                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: isDesktop ? 'bodySmall' : 'bodyMedium', sx: {
                                            color: snoozed ? 'primary.400' : 'primary.600',
                                            display: 'block',
                                        } }, { children: title })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: isDesktop ? 'bodyXSmall' : 'bodySmall', sx: {
                                            color: 'primary.400',
                                        } }, { children: (0, utils_1.timeSince)(timeCreated) }))] })), showDeviceName && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '1.2rem' } }, { children: Link }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'flex-end',
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.TwoToneArrowRight, { style: {
                                marginRight: '40px',
                                overflow: 'visible',
                            }, className: "right-arrow", height: '15px', width: '12px' }) }))] }))] }), uuid));
}
exports.default = AlertItem;
